import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const carousels = document.querySelectorAll(".carousel-wrapper");

carousels.forEach((wrapper) => {
  const track = wrapper.querySelector(".carousel-track");
  const slides = Array.from(wrapper.querySelectorAll(".carousel-slide"));
  const btnLeft = wrapper.querySelector(".carousel-left");
  const btnRight = wrapper.querySelector(".carousel-right");
  let index = 0;

  function updateActiveClass() {
    slides.forEach((slide) => slide.classList.remove("active"));
    slides[index].classList.add("active");
  }

  function updateCarousel() {
    track.style.transform = `translateX(${-index * 100}%)`;
    updateActiveClass();
  }

  btnRight.addEventListener("click", () => {
    index = (index + 1) % slides.length;
    updateCarousel();
  });

  btnLeft.addEventListener("click", () => {
    index = (index - 1 + slides.length) % slides.length;
    updateCarousel();
  });

  function setSlideWidth() {
    const slideWidth = track.clientWidth;
    slides.forEach((slide) => {
      slide.style.minWidth = `${slideWidth}px`;
    });
  }

  window.addEventListener("resize", () => {
    setSlideWidth();
    updateCarousel();
  });

  setSlideWidth();
  updateCarousel();
});

const cursor = document.getElementById("cursor");

document.addEventListener("mousemove", (e) => {
  cursor.style.left = e.clientX + "px";
  cursor.style.top = e.clientY + "px";

  const elem = document.elementFromPoint(e.clientX, e.clientY);

  if (!elem) return;

  const section = elem.closest(".background-light, .background-black");

  if (!section) return;

  if (section.classList.contains("background-black")) {
    cursor.style.backgroundColor = "#4abcc9";
  } else if (section.classList.contains("background-light")) {
    cursor.style.backgroundColor = "#fe8f2d";
  }
});
